<template>
  <ul class="report_list">
    <li v-for="item in reportList" :key="item.id" class="report_item">
      <div class="report_info">
        <div class="portrait" @click="toReportDetail(item)">
          <img :src="item.memberResourceUrl" alt="">
        </div>
        <div class="text" @click="toReportDetail(item)">
          <div class="nick" v-text="item.memberNickname"></div>
          <div class="time" v-text="item.publishTime"></div>
        </div>
        <div class="status_box" v-if="channelId==-1">
          <span class="status" v-if="item.status==0">未审核</span>
          <span class="status status1" v-else-if="item.status==1">审核通过</span>
          <span class="status status2" v-else-if="item.status==2">审核未通过</span>
          <span class="status status2" v-else-if="item.status==3">审核通过被取消</span>
        </div>
        <div class="button_con">
          <button class="praise_btn" @click="onPraiseClick($event,item)">
            <Icon iconClass="praise-o" /><Icon iconClass="praise" /><span v-text="item.topCount"></span>
          </button>
        </div>
      </div>
      <div class="report_other_info">
        <div class="report_content" v-text="item.description" @click="toReportDetail(item)"></div>
        <van-row class="report_img_list" v-if="!!item.pictureUrlList && item.pictureUrlList.length>0 && item.pictureUrlList.length<=3">
          <van-col span="8" v-for="(pic, i) in item.pictureUrlList" :key="i">
            <div class="report_img_item">
              <div class="report_img_box">
                <img :src="pic" alt="" :onerror="imgLoadError(item)" v-if="pic.length > 0" />
              </div>
            </div>
          </van-col>
        </van-row>
        <van-row class="report_img_list" v-else-if="!!item.pictureUrlList && item.pictureUrlList.length > 3">
          <van-col span="8">
            <div class="report_img_item">
              <div class="report_img_box">
                <img :src="item.pictureUrlList[0]" alt="" :onerror="imgLoadError(item)" v-if="item.pictureUrlList[0].length > 0" />
              </div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="report_img_item">
              <div class="report_img_box">
                <img :src="item.pictureUrlList[1]" alt="" :onerror="imgLoadError(item)" v-if="item.pictureUrlList[1].length > 0" />
              </div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="report_img_item">
              <div class="report_img_box">
                <img :src="item.pictureUrlList[2]" alt="" :onerror="imgLoadError(item)" v-if="item.pictureUrlList[2].length > 0" />
              </div>
            </div>
          </van-col>
          <div class="pic_num" v-text="item.pictureUrlList.length + '图'"></div>
        </van-row>
        <div class="report_location" v-if="!!item.address && item.address.length>0" @click="toReportDetail(item)">
          <Icon iconClass="locate" /><span v-text="item.address"></span>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "ReportList",
  props: {
    contentList: {
      type: Array,
      default: [],
    },
    channelId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId"]),
  },
  data() {
    return {
      reportList: [],
    };
  },
  watch: {
    contentList: {
      handler(newVal, oldVal) {
        this.reportList = deepClone(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 跳转报料详情 */
    toReportDetail(data) {
      this.$router.push({
        path: "/report_detail",
        query: {
          contentType: 16,
          contentId: data.id,
        },
      });
    },
    /* 点赞、取消点赞 */
    onPraiseClick(event, item) {
      var _this = this;
      var target = event.currentTarget;
      let clsArray = target.classList;

      var params = {
        contentType: 16,
        contentId: item.id,
        fromFlag: 0,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      if (clsArray.contains("praised")) {
        commApi
          .cancelThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              clsArray.remove("praised");
              item.topCount = res.data.topCount;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        commApi
          .giveThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              target.classList.add("praised");
              item.topCount = res.data.topCount;
            } else if (res.message == "这篇文章您已经点过赞了") {
              target.classList.add("praised");
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
  },
  created() {
    this.reportList = deepClone(this.contentList);
  },
};
</script>
<style scoped lang="scss">
.report_list {
  width: 100%;
  .report_item {
    width: 100%;
    padding: 10px 15px;
    background-color: #fff;
    margin-bottom: 8px;
    .report_info {
      position: relative;
      display: flex;
      height: 54px;
      padding: 8px 0 0 0;
      .portrait {
        width: 38.4px;
        height: 38.4px;
        line-height: 38.4px;
        overflow: hidden;
        background-image: url(~@/assets/images/user_default.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border: 1px solid #fff;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        img {
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
      .text {
        position: relative;
        width: 100%;
        overflow: hidden;
        flex: 1;
        line-height: 20px;
        padding: 0 6px;
        .nick {
          color: #242424;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 20px;
        }
        .time {
          color: #b8b3ad;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-family: "Microsoft YaHei";
        }
      }
      .status_box {
        margin-right: 10px;
        line-height: 20px;
        .status {
          font-size: 14px;
          color: #f49621;
          &.status1 {
            color: #0389cf;
          }
          &.status2 {
            color: #ff513f;
          }
        }
      }
      .button_con {
        text-align: right;
        .praise_btn {
          background: none;
          color: #a1a1a1;
          font-size: 12px;
          border: none;
          outline: none;
          white-space: nowrap;
          .tj-svg-icon {
            margin-right: 3px;
            font-size: 16px;
            vertical-align: -2.4px;
            &.tj-icon-praise {
              display: none;
            }
          }
          &.praised {
            color: #318bff;
            .tj-svg-icon {
              &.tj-icon-praise {
                display: inline;
              }
              &.tj-icon-praise-o {
                display: none;
              }
            }
          }
        }
      }
    }
    .report_other_info {
      .report_content {
        max-height: 45px;
        line-height: 22.5px;
        padding: 0;
        overflow: hidden;
        color: #1a1a1a;
        font-size: 17px;
        font-weight: normal;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .report_img_list {
        position: relative;
        margin-left: -2.4px;
        margin-right: -2.4px;
        .report_img_item {
          position: relative;
          height: 0;
          padding-bottom: 75%;
          margin: 2.4px;
          overflow: hidden;
          border-radius: 5px;
          .report_img_box {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: url(~@/assets/images/default_pic_16_9.png);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            display: flex;
            justify-content: center;
            img {
              object-fit: cover;
              min-width: 100%;
              min-height: 100%;
            }
          }
        }
        .pic_num {
          position: absolute;
          right: 10px;
          bottom: 10px;
          line-height: 20px;
          padding: 0 5px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 10px;
          color: #fff;
          font-size: 14px;
        }
      }
      .report_location {
        line-height: 24px;
        .tj-svg-icon {
          color: #a6a6a6;
          margin-right: 5px;
          font-size: 14px;
        }
        span {
          color: #666;
          font-size: 14px;
        }
      }
    }
  }
}
</style>